export enum P2PIndexStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Submitted = 'Submitted'
}

export enum P2PBuildingIndexStatus {
  NotStarted = 'NotStarted',
  Pending = 'Pending',
  Submitted = 'Submitted',
  Edited = 'Edited'
}

export interface P2PReportingYear {
  id: number
  label: string
  startDate: string
  endDate: string
  softDueDate?: string | null
}

export interface CollectionBuilding {
  organizationBuildingId: number
  name: string
  status: P2PBuildingIndexStatus
  requiredTotal: number
  requiredAnswered: number
  isComplete: boolean
  lastUpdatedAt?: string
  submittedByName?: string
  submittedAt?: string | null
  isLocked: boolean
  hasActiveProgram: boolean | null
}

export interface CollectionDistrict {
  districtOrganizationId: number
  name: string
  isdOrganizationId?: number | null
  isdName?: string
  buildings: CollectionBuilding[]
}

export interface CompletionsIsdGroup {
  isdOrganizationId: number
  isdName: string
  districts: CollectionDistrict[]
}

export interface CompletionsView {
  isds: CompletionsIsdGroup[]
}

export interface CollectionIndex {
  activeReportingYear?: P2PReportingYear | null
  isEnterable: boolean
  awaitingInvitation: boolean
  needsDistrictSelection: boolean
  isdName: string
  indexStatus: P2PIndexStatus
  districts: CollectionDistrict[]
}

export interface CollectionFormView {
  schema: string
  answers?: string | null
  status: P2PBuildingIndexStatus
  hasActiveProgram: boolean
  isReadOnly: boolean
}

export interface CollectionSubmissionSummary {
  answers?: string | null
  status: P2PBuildingIndexStatus
  submittedByName: string
  submittedAt?: string | null
}

export interface SaveP2PFormRequest {
  organizationBuildingId: number
  reportingYearId: number
  answersJson: string
  hasActiveProgram: boolean
}

export interface SaveP2PFormResult {
  requiredTotal: number
  requiredAnswered: number
  isComplete: boolean
}

export interface SetProgramStatusRequest {
  organizationBuildingId: number
  reportingYearId: number
  hasActiveProgram: boolean
  notesToStart?: string
}

export interface SubmitReportRequest {
  reportingYearId: number
}

export interface SubmitReportResult {
  indexStatus: P2PIndexStatus
  submittedCount: number
}

export interface DistrictOption {
  id: number
  name: string
}

export interface MyDistrictsView {
  available: DistrictOption[]
  selectedDistrictIds: number[]
}

export interface UpdateMyDistrictsRequest {
  reportingYearId: number
  districtOrganizationIds: number[]
}
